class BundleGroups extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('.bundle-ids');
        this.addEventListener('change', this.setIds.bind(this));
        this.setIds();
    }
    setIds() {
        const array = [];
        this.querySelectorAll('input[type="radio"]:checked').forEach( input => {
            array.push(input.value);
        })

        this.input.value =array.join(',');
    }
}

customElements.define('bundle-groups', BundleGroups)